import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GeaoContext } from "../../GeaoContextProvider";
import { GeaoPaths } from "../../constants/GeaoPaths";
import { getAnswer } from "../../mappers/InterviewMapper";
import Role from "../../constants/Role";

export default function useCreateYourProfileNavigation(
    duplicateAgency,
    duplicateAgent,
    niprAgencyNameChange,
    niprAgentNameChange,
    niprNameChangeAccepted,
    agencyAssessmentKickout,
    agentAssessmentKickout,
    parentAgencyMustOnboard,
    agencyOffshoreMustBeApproved
) {
    const { agentInterview } = useContext(GeaoContext);
    const navigate = useNavigate();

    /**
     * Navigate to the recall flow if a duplicate interview was found.
     */
    useEffect(() => {
        if (duplicateAgency || duplicateAgent) {
            navigate(GeaoPaths.ApplicationStatus);
        }
    }, [duplicateAgency, duplicateAgent]);

    /**
     * Navigate to the assessment kickout page.
     */
    useEffect(() => {
        if (agencyAssessmentKickout || agentAssessmentKickout) {
            navigate(GeaoPaths.CreateYourProfileKickout);
        }
    }, [agencyAssessmentKickout, agentAssessmentKickout]);

    /**
     * Navigate to the Welcome Checklist page.
     */
    useEffect(() => {
        if (agentInterview?.status !== "Active") return;
        if (duplicateAgency || duplicateAgent) return;
        if ((niprAgencyNameChange || niprAgentNameChange) && !niprNameChangeAccepted) return;
        if (agencyAssessmentKickout || agentAssessmentKickout) return;
        if (parentAgencyMustOnboard) return;
        if (agencyOffshoreMustBeApproved) return;

        const welcomeChecklistPath = getAnswer(agentInterview, "Role") === Role.Principal ?
            GeaoPaths.PrincipalWelcomeChecklist :
            GeaoPaths.ProducerWelcomeChecklist;

        navigate(welcomeChecklistPath);
    }, [
        duplicateAgency,
        duplicateAgent,
        niprAgencyNameChange,
        niprAgentNameChange,
        niprNameChangeAccepted,
        agencyAssessmentKickout,
        agentAssessmentKickout,
        parentAgencyMustOnboard,
        agencyOffshoreMustBeApproved,
        agentInterview
    ]);
}